import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconTags = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 5C2.44772 5 2 5.44772 2 6V12.6667C2 12.9321 2.10552 13.1866 2.29331 13.3742L8.01938 19.0936C8.45702 19.5316 9.05081 19.7777 9.67 19.7777C10.2893 19.7777 10.8832 19.5315 11.3208 19.0934L12.1695 18.2447L13.0194 19.0936C13.457 19.5316 14.0508 19.7777 14.67 19.7777C15.2893 19.7777 15.8832 19.5315 16.3208 19.0934L21.1004 14.3138L20.3933 13.6067L21.1025 14.3117C22.0072 13.4016 22.0072 11.9318 21.1025 11.0217L15.3738 5.29289C15.1862 5.10536 14.9319 5 14.6667 5H9.66667H8H3ZM8 7H4V12.2521L9.43417 17.68C9.49669 17.7425 9.58153 17.7777 9.67 17.7777C9.75847 17.7777 9.84331 17.7425 9.90583 17.68L14.6841 12.9017C14.8125 12.7718 14.8131 12.5622 14.6848 12.4323L9.25245 7H8ZM12.0809 7L16.1025 11.0217C17.0072 11.9318 17.0072 13.4016 16.1025 14.3117L16.1004 14.3138L13.5837 16.8305L14.4342 17.68C14.4967 17.7425 14.5815 17.7777 14.67 17.7777C14.7585 17.7777 14.8433 17.7425 14.9058 17.68L19.6841 12.9017C19.8125 12.7718 19.8131 12.5622 19.6848 12.4323L14.2525 7H12.0809Z"
        />
      </svg>
    );
  }
);
